import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '../../lib/utils';

const WarningProgress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => {
  const v = Math.min(Math.floor(value / 25), 3);
  const colors = [
    'hsl(var(--sparqle-warning-1))',
    'hsl(var(--sparqle-warning-2))',
    'hsl(var(--sparqle-warning-3))',
    'hsl(var(--sparqle-warning-4))',
  ];
  console.log({ v });
  const color = colors[v];

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn('relative h-2 w-full overflow-hidden rounded-full bg-primary/20', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={`h-full w-full flex-1 transition-all`}
        style={{ transform: `translateX(-${100 - (value || 0)}%)`, backgroundColor: color }}
      />
    </ProgressPrimitive.Root>
  );
});
WarningProgress.displayName = ProgressPrimitive.Root.displayName;

export { WarningProgress };
